'use strict';
/* global $ */
var afterpay;

/**
 * Populates afterpay popup modal
 * @param {jquery} e - jquery element
 */
function openAfterpayModal(e) {
    e.preventDefault();

    var url = $(this).prop('href');

    $.get(url, function (data) {
        if ($('#afterpayModal').length) {
            $('#afterpayModal').remove();
        }
        var htmlString = '<!-- Modal -->' +
            '<div class="modal fade afterpayModal" id="afterpayModal" role="dialog">' +
            '<div class="modal-dialog quick-view-dialog">' +
            '<!-- Modal content-->' +
            '<div class="modal-content">' +
            '<div class="modal-header">' +
            '    <h4 class="modal-title">Shop now, pay Later.</h4>' +
            '    <button type="button" class="close-afterpay pull-right" data-dismiss="modal">' +
            '        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"' +
            '        viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">' +
            '           <g id="Layer_3">' +
            '               <path class="icon-path icon-close" d="M3.89,6.15L17.74,20L3.89,33.85c-0.63,0.63-0.63,1.64,0,2.26c0.63,0.63,1.64,0.63,2.26,0L20,22.26l13.85,13.85' +
            '                    c0.63,0.63,1.64,0.63,2.26,0c0.63-0.63,0.63-1.64,0-2.26L22.26,20L36.11,6.15c0.63-0.63,0.63-1.64,0-2.26' +
            '                      c-0.63-0.63-1.64-0.63-2.26,0L20,17.74L6.15,3.89c-0.63-0.63-1.64-0.63-2.26,0C3.26,4.51,3.26,5.53,3.89,6.15z"/>' +
            '            </g>' +
            '        </svg>' +
            '    </button>' +
            '</div>' +
            '<div class="modal-body">' + data + '</div>' +
            '</div>' +
            '</div>' +
            '</div>';
        $('body').append(htmlString);
        $('body').addClass('modal-open');
        $('#afterpayModal').addClass('show');

        $('#overview-container-circles img').on('load', function () {
            afterpay.popupVerticalCenter();
        });
    });
}

afterpay = {
    init: function () {
        $('body').on('click', '.afterpay-link a', openAfterpayModal);

        $('body').on('click', '#afterpayModal .modal-header button', function () {
            $('#afterpayModal').remove();
            $('body').removeClass('modal-open');
        });
    }
};

module.exports = afterpay;
